import { GetIcon, icons } from '@assets/component/Icons/Icons';
import { TaskPage } from '@assets/component/TaskPage/TaskPage';
import { TaskScore } from '@assets/component/TaskPage/TaskScore/TaskScore';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import {
    TaskEvalResults,
    useStore,
    useStoreUI,
    useTasksStore,
    useClientSettingStore
} from '@assets/model/Store';
import { onValue, ref } from 'firebase/database';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import * as style from './WorkstreamsPage.module.less';

export const WorkStreamPage = observer(() => {
    const store = useStore();
    const uiStore = useStoreUI();
    const taskStore = useTasksStore();
    const clientSettings = useClientSettingStore();
    const taskPageOpen = uiStore.workstreamModuleTaskId != null;

    const openModule = (taskId: string) => {
        store.selectedTaskId = taskId;
        uiStore.workstreamModuleTaskId = taskId;
    };
    const closeModule = () => {
        uiStore.workstreamModuleTaskId = null;
    };

    const [taskEvalsResultsReport, setTaskEvalResultsForReport] = useState<{
        [key: string]: TaskEvalResults[];
    }>();

    useEffect(() => {
        // Leaving the Workstreams tab returns to the overview.
        return () => closeModule();
    }, []);

    useEffect(
        function fetchTaskEvals() {
            const path = `/flowtasks/eval_results/${store.selectedReportId}`;
            const fb = getFirebase();
            const r = ref(fb.db, path);
            const unsub = onValue(r, snapshot => {
                const data = snapshot.val();
                console.log('WorkstreamsPage: fetched evals results:', data);
                setTaskEvalResultsForReport(data ?? []);
            });

            return () => {
                unsub();
            };
        },
        [store.selectedReportId]
    );
    const getTaskEvalResults = (taskId: string): number => {
        const taskData = taskEvalsResultsReport?.[taskId];
        if (!taskData) return -1;
        const totalEvals = taskData.length;
        const validEvals = taskData.filter(e => e.is_valid).length;
        const percentValid = Math.round((validEvals / totalEvals) * 100);
        return percentValid;
    };

    const tasksState = store.activeReportTasksState;
    const makeTaskGroup = (title: string, taskIdsList: string[]) => {
        const tasks = taskIdsList.map(taskId => {
            const taskState = tasksState.getTaskQuery(taskId);
            //getTaskData(taskId);
            const taskDefinition = taskStore.get_task_definition(taskId);

            //defaults for static UI
            var totalSteps = 3;

            //This static steps code is for demo purposes only
            if (taskId === 'Customer Feedback') {
                totalSteps = 2;
            }
            var isTaskComplete = false;
            var activeStep = 1;
            var taskName = taskId;
            var icon: icons = 'task-locked';

            if (taskDefinition) {
                totalSteps = taskDefinition.inner_steps_names.length;
                taskName = taskDefinition.name;
            }

            if (taskState) {
                isTaskComplete = taskState.isComplete;
                activeStep = taskState.activeStep;

                const taskStatus = taskState.status;

                if (taskState.isLocked) {
                    icon = 'task-locked';
                } else if (isTaskComplete) {
                    icon = 'task-checkmark';
                    //Show % of evals passed
                } else {
                    if (taskStatus == 'in_progress') {
                        icon = 'task-working';
                    } else {
                        icon = 'task-paused'; //# or locked ?
                    }
                }
            }

            var workItemsString = `${activeStep}/${totalSteps} Work items completed`;
            var iconEl = (
                <div className={style.taskIcon}>
                    <img src={GetIcon(icon)} className={style.iconSize} />
                </div>
            );
            if (icon == 'task-checkmark') {
                //Overide this icon to show eval results
                var taskResults = getTaskEvalResults(taskId);
                iconEl = (
                    <div className={style.taskPercentBg}>
                        <TaskScore score={taskResults} />
                    </div>
                );
            }
            return (
                <div
                    key={taskId}
                    className={`${style.taskBox} hover-button-small`}
                >
                    <Flex
                        fillCell={true}
                        direction="row"
                        className={style.taskBoxContent}
                    >
                        <Flex
                            direction="column"
                            fillCell={true}
                            onClick={() => {
                                if (!taskDefinition) return;
                                if (taskState.isLocked) return;

                                openModule(taskId);
                            }}
                        >
                            <div className={style.taskTitle}>{taskName}</div>
                            <div style={{ flexGrow: 1 }}></div>
                            <div className={style.taskStatus}>
                                {workItemsString}
                            </div>
                        </Flex>
                        {iconEl}
                    </Flex>
                </div>
            );
        });

        return (
            <Flex
                fillCell={true}
                direction="column"
                className={style.taskGroup}
            >
                <div className={style.taskGroupTitle}>{title}</div>
                {tasks}
            </Flex>
        );
    };

    const workstreamsGroups = clientSettings.workstreamsGroups;

    const onClickClear = () => {
        const areYouSure = window.confirm('Are you sure you want to clear?');

        if (!areYouSure) return;

        const fb = getFirebase();
        const reportId = store.selectedReportId;
        const tasksToClear = workstreamsGroups.flatMap(g => g.task_ids);

        for (const taskId of tasksToClear) {
            fb.flowtask_add_clear_job(reportId, taskId);
        }

        fb.flowtask_clear_all_variables(reportId);
    };

    return (
        <div className={style.workstreamsRoot}>
            <i
                className={'bi bi-trash' + ' ' + style.clearButton}
                style={{
                    color: 'black',
                    display: taskPageOpen ? 'none' : 'block'
                }}
                onClick={() => {
                    onClickClear();
                }}
            ></i>
            <div
                className={style.taskViewContainer}
                style={{
                    display: taskPageOpen ? 'block' : 'none'
                }}
            >
                <TaskPage
                    onClickBack={() => {
                        closeModule();
                    }}
                />
            </div>
            <Flex direction="row" className={style.flexsContainer}>
                {workstreamsGroups.map(g => makeTaskGroup(g.title, g.task_ids))}
            </Flex>
        </div>
    );
});
